import { ICReport } from '@fortem-monorepo/web-sdk'

import { RatesDeltaChart } from '@/pages/funds/ic-report/components/primitives/charts/RatesDeltaChart'
import { RatesGammaChart } from '@/pages/funds/ic-report/components/primitives/charts/RatesGammaChart'
import { RatesVegaChart } from '@/pages/funds/ic-report/components/primitives/charts/RatesVegaChart'

export interface RatesVolatilityProps {
  params: Omit<ICReport.GetICReportDataParams, 'endpoint'>
}

export const RatesVolatility: React.FC<RatesVolatilityProps> = ({ params }) => {
  return (
    <div className={'grid grid-cols-3'}>
      <RatesDeltaChart params={params} />
      <RatesGammaChart params={params} />
      <RatesVegaChart params={params} />
    </div>
  )
}
